<template>
	<div>
		<div v-if="!clientInfo" class="auth-wrapper auth-v1 gap-x-10 lg:gap-x-24 flex-wrap gap-y-5 py-10 md:py-0">
			<div class="w-full md:w-6/12 lg:w-4/12 px-10 flex flex-col justify-center">
				<div class="mb-16 mx-auto self-start">
					<img src="../../assets/icons/journey-green-logo.svg" alt="Logo Journey" />
				</div>
				<custom-input
					v-for="(header, index) in headers"
					:key="index"
					:label="header.name"
					v-model="loginData[header.key]"
					:type="header.type"
					:placeholder="header.placeholder"
					:error="header.error"
					inputStyle="secondary"
					class="mb-2"
					:handleEnterSubmit="header.enterSubmit"
					:mask="header.inputMask"
				></custom-input>

				<custom-button :disabled="loading" :onClick="retriveClientInfo" :loading="loading" class="py-1 w-full mt-2"
					>Entrar</custom-button
				>
			</div>
		</div>
		<div v-if="clientInfo" class="flex flex-col gap-4 min-h-screen">
			<client-goals :clientInfo="clientInfo" />
		</div>
	</div>
</template>

<script>
	import { Component, Vue } from "vue-property-decorator";
	import goalsModel from "@/api/goals.model";
	import ClientGoals from "@/layouts/components/ClientGoals.vue";
	import CustomInput from "@/layouts/components/Input.vue";
	import CustomButton from "@/layouts/components/Button.vue";
	import { showErrorAlert } from "@/helpers";

	@Component({
		components: {
			ClientGoals,
			CustomInput,
			CustomButton,
		},
	})
	export default class GoalsPanel extends Vue {
		clientInfo = null;
		isExpanded = {
			Necessidades: false,
			"Riscos de saúde": false,
			Diagnósticos: false,
			"Linha de cuidado personalizada": false,
		};
		headers = [
			{
				name: "CPF",
				key: "cpf",
				placeholder: "123.123.123-12",
				inputMask: "cpf",
				error: "",
				enterSubmit: this.signIn,
			},
			{
				name: "Código de Acesso",
				key: "accessCode",
				type: "password",
				placeholder: "Digite o código de acesso",
				error: "",
				enterSubmit: this.signIn,
			},
		];
		loginData = {
			cpf: "",
			accessCode: "",
		};
		loading = false;

		mounted() {
			document.title = "Journey | Perfil Saúde";
		}

		async retriveClientInfo() {
			try {
				this.loading = true;
				const clientInfo = await goalsModel.getGoalsInformations(
					this.$route.params.id,
					this.loginData.cpf,
					this.loginData.accessCode,
				);

				this.clientInfo = clientInfo;
			} catch (error) {
				showErrorAlert(error.message);
			}
			this.loading = false;
		}
	}
</script>

<style lang="scss">
	@import "@core/scss/vue/pages/page-auth.scss";
</style>
